import { z } from 'zod';
/**
 * Reporting & tableaux de bord (Sprint 6b, `apps/api/src/modules/reporting/`).
 * Les schémas de requête ci-dessous sont importés tels quels par
 * `reporting.routes.ts` ; les interfaces de réponse restent dupliquées côté
 * front (`apps/web/src/features/reporting/api.ts`), même convention que
 * `StockView`/`MouvementLogistique` dans le module logistique.
 */
export const activiteAgentsQuerySchema = z.object({
    jours: z.coerce.number().int().min(1).max(365).default(30),
});
export const enrolementsParPeriodeQuerySchema = z.object({
    jours: z.coerce.number().int().min(1).max(180).default(30),
});
//# sourceMappingURL=reporting.js.map